import { z } from "zod";

import { AssetKind, AssetOrder, AssetSource } from "../../api/generated/zod";
import { LIBRARY_SEARCH_MAX } from "../../platform/media/library-pages";

// `?kind=&folder=&nested=&scope=&view=&trash=&saving=&q=&source=&by=&product=&order=`: anything malformed is dropped, never an
// error page. `saving` is an asset a job's "Save to library" just asked for, shown until it is
// ready. `q` is the search, `by` the creators, `product` live's Product filter (#246).
export const librarySearch = z.object({
  kind: AssetKind.optional().catch(undefined),
  folder: z.uuid().optional().catch(undefined),
  // Live's "Show nested": the folder's subprojects' files too (spec A3b).
  nested: z.boolean().optional().catch(undefined),
  // Live's project scope (#445): every file of the brand while the folder stays chosen.
  scope: z.literal("all").optional().catch(undefined),
  // Live's view switch (#446): the folder's subprojects as cards over the gallery.
  view: z.literal("folders").optional().catch(undefined),
  trash: z.boolean().optional().catch(undefined),
  saving: z.uuid().optional().catch(undefined),
  // A copied link's file (live's "Copy link", S1 decision 22): it opens in the preview.
  preview: z.uuid().optional().catch(undefined),
  q: z.string().max(LIBRARY_SEARCH_MAX).optional().catch(undefined),
  source: AssetSource.optional().catch(undefined),
  by: z.array(z.uuid()).optional().catch(undefined),
  product: z.uuid().optional().catch(undefined),
  order: AssetOrder.optional().catch(undefined),
});

/** The library's view, as its URL holds it. */
export type LibrarySearch = z.infer<typeof librarySearch>;
